import { useMemo, useState } from "react";
import { CATEGORIES, PRODUCTS } from "../data/products";
import type { Category } from "../types";
import { ProductCard } from "../components/ProductCard";

type Filter = Category | "all";

export function Products() {
	const [filter, setFilter] = useState<Filter>("all");

	const filtered = useMemo(
		() =>
			filter === "all"
				? PRODUCTS
				: PRODUCTS.filter((product) => product.category === filter),
		[filter]
	);

	return (
		<section>
			<div className="flex items-center justify-between gap-4 flex-wrap">
				<h1 className="text-3xl font-bold text-slate-900">Products</h1>
				<span
					data-testid="products-count"
					className="text-sm text-slate-600"
				>
					{filtered.length} item{filtered.length === 1 ? "" : "s"}
				</span>
			</div>
			<div className="mt-6 flex flex-wrap gap-2">
				{CATEGORIES.map((cat) => {
					const active = filter === cat.id;
					return (
						<button
							key={cat.id}
							type="button"
							onClick={() => setFilter(cat.id)}
							data-testid={`filter-${cat.id}`}
							className={
								"rounded-full border px-4 py-1.5 text-sm transition-colors " +
								(active
									? "bg-slate-900 text-white border-slate-900"
									: "bg-white text-slate-700 border-slate-300 hover:border-slate-500")
							}
						>
							{cat.label}
						</button>
					);
				})}
			</div>
			<div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
				{filtered.map((product) => (
					<ProductCard key={product.id} product={product} />
				))}
			</div>
		</section>
	);
}

export default Products;
